import { IRoutePattern } from "../@types/Route";
import { CalendarOneDot } from "../assets/icons/CalendarOneDot";
import { CircleTickPlus } from "../assets/icons/CircleTickPlus";
import { Lab } from "../assets/icons/Lab";
import { Panel } from "../assets/icons/Panel";
import { Vitals } from "../assets/icons/Vitals";

export const mainRoutes: IRoutePattern[] = [
  {
    name: "Patients",
    labelKey: "nav_main_patients",
    path: "/patients",
    disabled: false,
    Icon: Panel,
  },
  {
    name: "Dashboard",
    labelKey: "nav_main_dashboard",
    path: "/dashboard",
    disabled: true,
    Icon: Vitals,
  },
  {
    name: "Surveys",
    labelKey: "nav_main_surveys",
    path: "/surveys",
    disabled: true,
    Icon: Lab,
  },
  {
    name: "Protocol",
    labelKey: "nav_main_protocol",
    path: "/protocol",
    disabled: true,
    Icon: CircleTickPlus,
  },
  {
    name: "Appointments",
    labelKey: "nav_main_appointments",
    path: "/appointments",
    disabled: true,
    Icon: CalendarOneDot,
  },
  {
    name: "Care Info",
    labelKey: "nav_main_careInfo",
    path: "/careinfo",
    disabled: true,
    Icon: Lab,
  },
  {
    name: "Workflows",
    labelKey: "nav_main_workflows",
    path: "/workflows",
    disabled: true,
    Icon: Lab,
  },
  {
    name: "RAG",
    labelKey: "nav_main_rag",
    path: "/rag",
    disabled: true,
    Icon: Vitals,
  },
];
